/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"')
      .replace(/\+/g, ' ') +
    '"}'
  )
}

export function obj2Param(param) {
  var str = Object.keys(param)
    .map(key => `${key}=${param[key]}`)
    .join('&')
  return str;
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

export function getStrLength(fData) {
  fData = fData || ''
  var intLength = 0
  for (var i = 0; i < fData.length; i++) {
    if ((fData.charCodeAt(i) < 0) || (fData.charCodeAt(i) > 255)) { intLength = intLength + 2 } else { intLength = intLength + 1 }
  }
  return intLength
}

export function DataLength(fData, number) {
  fData = fData || ''
  var intLength = 0
  for (var i = 0; i < fData.length; i++) {
    if ((fData.charCodeAt(i) < 0) || (fData.charCodeAt(i) > 255)) { intLength = intLength + 2 } else { intLength = intLength + 1 }
  }
  return intLength > number ? fData.substr(0, Math.ceil(number / 2)) + '...' : fData
}
export function blobCheck(res) {
  const blob = new Blob([res], {
    type: 'text/plain'
  })
  // 将Blob 对象转换成字符串
  var reader = new FileReader()
  reader.readAsText(blob, 'GBK')// gb2312
  reader.onload = (e) => {
    if (reader.result && reader.result.indexOf('code') !== -1 && reader.result.indexOf('100008') !== -1 && reader.result.indexOf('msg') !== -1) {
      this.$message.error('内容下载失败！')
    } else {
      return true
    }
  }
  reader.onerror = (e) => {
    this.$message.error('内容下载失败！')
  }
  return false
}

export const time = (timeStamp) => {
  const obj = {}
  let year = new Date(timeStamp).getFullYear();
  let month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
  let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
  let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
  let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
  let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
  let week = new Date(timeStamp).getDay();
  let weeks = ["日", "一", "二", "三", "四", "五", "六"];
  let getWeek = "星期" + weeks[week];
  obj.data = year + "-" + month + "-" + date
  obj.time = `${hh}:${mm}:${ss}`
  obj.week = getWeek
  return obj
}

export const getDay = (day) => {
  var today = new Date();
  var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
  today.setTime(targetday_milliseconds); //注意，这行是关键代码
  var tYear = today.getFullYear();
  var tMonth = today.getMonth();
  var tDate = today.getDate();
  tMonth = doHandleMonth(tMonth + 1);
  tDate = doHandleMonth(tDate);
  return tYear+"-"+tMonth+"-"+tDate;
}

export const doHandleMonth = (month) => {
  var m = month;
  if(month.toString().length == 1){
    m = "0" + month;
  }
  return m;
}